export default function (containerEl, explanationEl, passwordVal) {
	const upperChar = /[A-Z]/g;
	const lowerChar = /[a-z]/g;
	const number = /[0-9]/g;
	const specialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;

	let strengthVal = 0;

	const initialMessage = explanationEl.textContent || "Password must be twelve (12) or more characters long and contain upper and lowercase letters, numbers, and special characters.";
	const messages = {
		complete: "Password meets all requirements!",
		charCount: "Password must contain upper and lowercase letters, numbers, and special characters.",
		upperChar: "Enter at least twelve (12) characters and use lowercase letters, numbers, and special characters.",
		lowerChar: "Enter at least twelve (12) characters and use uppercase letters, numbers, and special characters.",
		number: "Enter at least twelve (12) characters and use upper and lowercase letters, and special characters.",
		specialChar: "Enter at least twelve (12) characters and use uppercase and lowercase letters, and numbers.",
		charCountUpperChar: "Password must contain lowercase letters, numbers and special characters.",
		charCountLowerChar: "Password must contain uppercase letters, numbers and special characters.",
		charCountNumber: "Password must contain upper and lowercase letters, and special characters.",
		charCountSpecialChar: "Password must contain upper and lowercase letters, and numbers.",
		upperLowerChar: "Enter at least twelve (12) characters and use numbers and special characters.",
		upperNumber: "Enter at least twelve (12) characters and use lowercase letters and special characters.",
		upperSpecialChar: "Enter at least twelve (12) characters and use lowercase letters and numbers.",
		lowerNumber: "Enter at least twelve (12) characters and use uppercase letters and special characters.",
		lowerSpecialChar: "Enter at least twelve (12) characters and use uppercase letters and numbers.",
		numberSpecialChar: "Enter at least twelve (12) characters and use uppercase and lowercase letters.",
		countUpperLowerNumber: "Password must contain special characters.",
		countUpperLowerSpecialChar: "Password must contain numbers.",
		countUpperNumberSpecialChar: "Password must contain lowercase letters.",
		countLowerNumberSpecialChar: "Password must contain uppercase letters.",
		upperLowerNumber: "Enter at least twelve (12) characters and use special characters.",
		upperLowerSpecialChar: "Enter at least twelve (12) characters and use numbers.",
		upperNumberSpecialChar: "Enter at least twelve (12) characters and use lowercase letters.",
		lowerNumberSpecialChar: "Enter at least twelve (12) characters and use uppercase letters.",
		countUpperLower: "Password must contain numbers and special characters.",
		countUpperNumber: "Password must contain lowercase letters and special characters.",
		countUpperSpecialChar: "Password must contain lowercase letters and numbers.",
		countLowerNumber: "Password must contain uppercase letters and special characters.",
		countLowerSpecialChar: "Password must contain uppercase letters and numbers.",
		countNumberSpecialChar: "Password must contain uppercase and lowercase letters.",
		upperLower: "Enter at least twelve (12) characters and use numbers, and special characters.",
		upperNumber: "Enter at least twelve (12) characters and use lowercase letters, and special characters.",
		upperSpecialChar: "Enter at least twelve (12) characters and use lowercase letters, and numbers.",
		lowerNumber: "Enter at least twelve (12) characters and use uppercase letters, and special characters.",
		lowerSpecialChar: "Enter at least twelve (12) characters and use uppercase letters, and numbers.",
		numberSpecialChar: "Enter at least twelve (12) characters and use upper and lowercase letters.",
		countUpper: "Password must contain numbers, special characters.",
		countLower: "Password must contain numbers, special characters.",
		countNumber: "Password must contain upper and lowercase letters, special characters.",
		countSpecialChar: "Password must contain upper and lowercase letters, numbers.",
		upperLowerNumberSpecialChar: "Enter at least twelve (12) characters.",
		none: initialMessage
	}

	if (passwordVal.trim().length == 0) {
		containerEl.classList.remove('new-password--active');
		containerEl.setAttribute('data-strength', 0);
		explanationEl.textContent = messages.none;
		return;
	} else {
		containerEl.classList.add('new-password--active');
		const meetsCharCount = passwordVal.length >= 12;
		const meetsUpperChar = !!passwordVal.match(upperChar)?.length;
		const meetsLowerChar = !!passwordVal.match(lowerChar)?.length;
		const meetsNumber = !!passwordVal.match(number)?.length;
		const meetsSpecialChar = !!passwordVal.match(specialChar)?.length;
		switch (true) {
			case meetsCharCount && meetsUpperChar && meetsLowerChar && meetsNumber && meetsSpecialChar:
				strengthVal = 5;
				explanationEl.textContent = messages.complete;
				break;
			case meetsCharCount && meetsUpperChar && meetsLowerChar && meetsNumber:
				strengthVal = 4;
				explanationEl.textContent = messages.countUpperLowerNumber;
				break;
			case meetsCharCount && meetsUpperChar && meetsLowerChar && meetsSpecialChar:
				strengthVal = 4;
				explanationEl.textContent = messages.countUpperLowerSpecialChar;
				break;
			case meetsCharCount && meetsUpperChar && meetsNumber && meetsSpecialChar:
				strengthVal = 4;
				explanationEl.textContent = messages.countUpperNumberSpecialChar;
				break;
			case meetsCharCount && meetsLowerChar && meetsNumber && meetsSpecialChar:
				strengthVal = 4;
				explanationEl.textContent = messages.countLowerNumberSpecialChar;
				break;
			case meetsUpperChar && meetsLowerChar && meetsNumber && meetsSpecialChar:
				strengthVal = 4;
				explanationEl.textContent = messages.upperLowerNumberSpecialChar;
				break;
			case meetsUpperChar && meetsLowerChar && meetsNumber && meetsSpecialChar:
				strengthVal = 4;
				explanationEl.textContent = messages.upperLowerNumberSpecialChar;
				break;
			case meetsUpperChar && meetsLowerChar && meetsNumber:
				strengthVal = 3;
				explanationEl.textContent = messages.upperLowerNumber;
				break;
			case meetsUpperChar && meetsLowerChar && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.upperLowerSpecialChar;
				break;
			case meetsUpperChar && meetsNumber && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.upperNumberSpecialChar;
				break;
			case meetsLowerChar && meetsNumber && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.lowerNumberSpecialChar;
				break;
			case meetsCharCount && meetsUpperChar && meetsLowerChar:
				strengthVal = 3;
				explanationEl.textContent = messages.countUpperLower;
				break;
			case meetsCharCount && meetsUpperChar && meetsNumber:
				strengthVal = 3;
				explanationEl.textContent = messages.countUpperNumber;
				break;
			case meetsCharCount && meetsUpperChar && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.countUpperSpecialChar;
				break;
			case meetsCharCount && meetsLowerChar && meetsNumber:
				strengthVal = 3;
				explanationEl.textContent = messages.countLowerNumber;
				break;
			case meetsCharCount && meetsLowerChar && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.countLowerSpecialChar;
				break;
			case meetsCharCount && meetsNumber && meetsSpecialChar:
				strengthVal = 3;
				explanationEl.textContent = messages.countNumberSpecialChar;
				break;
			case meetsUpperChar && meetsLowerChar:
				strengthVal = 2;
				explanationEl.textContent = messages.upperLower;
				break;
			case meetsUpperChar && meetsNumber:
				strengthVal = 2;
				explanationEl.textContent = messages.upperNumber;
				break;
			case meetsUpperChar && meetsSpecialChar:
				strengthVal = 2;
				explanationEl.textContent = messages.upperSpecialChar;
				break;
			case meetsLowerChar && meetsNumber:
				strengthVal = 2;
				explanationEl.textContent = messages.lowerNumber;
				break;
			case meetsLowerChar && meetsSpecialChar:
				strengthVal = 2;
				explanationEl.textContent = messages.lowerSpecialChar;
				break;
			case meetsNumber && meetsSpecialChar:
				strengthVal = 2;
				explanationEl.textContent = messages.numberSpecialChar;
				break;
			case meetsCharCount && meetsUpperChar:
				strengthVal = 2;
				explanationEl.textContent = messages.charCountUpperChar;
				break;
			case meetsCharCount && meetsLowerChar:
				strengthVal = 2;
				explanationEl.textContent = messages.charCountLowerChar;
				break;
			case meetsCharCount && meetsNumber:
				strengthVal = 2;
				explanationEl.textContent = messages.charCountNumber;
				break;
			case meetsCharCount && meetsSpecialChar:
				strengthVal = 2;
				explanationEl.textContent = messages.charCountSpecialChar;
				break;
			case meetsCharCount:
				strengthVal = 1;
				explanationEl.textContent = messages.charCount;
				break;
			case meetsUpperChar:
				strengthVal = 1;
				explanationEl.textContent = messages.upperChar;
				break;
			case meetsLowerChar:
				strengthVal = 1;
				explanationEl.textContent = messages.lowerChar;
				break;
			case meetsNumber:
				strengthVal = 1;
				explanationEl.textContent = messages.number;
				break;
			case meetsSpecialChar:
				strengthVal = 1;
				explanationEl.textContent = messages.specialChar;
				break;
			default:
				strengthVal = 0;
				explanationEl.textContent = messages.none;
				break;
		}
		containerEl.setAttribute("data-strength", strengthVal);
	}
}